<template>
  <div class="container-fluid">
  
     
      <BPComponent></BPComponent>
     
  </div>
 
</template>

<script>
import BPComponent from '@/components/BPComponent.vue';

  export default{
    components:{
   BPComponent
    }
  }
</script>

<style scoped>
.container-fluid{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Faz a div ocupar 100% da altura da tela */
  width: 100vw;  /* Faz a div ocupar 100% da largura da tela */
  background-image: url('@/assets/fundobranco.webp');
  background-size: cover;        /* Faz a imagem cobrir toda a área */
  background-position: center;   /* Centraliza a imagem */
  background-repeat: no-repeat;
}

</style>